export const Spacer = ({ height = '10px' }) => <div style={{ height }} />;

